import { css } from '@repo/pandacss/styled-system/css';
import type { ElementType, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  Component?: ElementType;
};
/**
 * This component is specifically for making text accessible to screen readers while keeping it visually hidden from the page.
 */
export const AccessibleHiddenText = ({ children, Component = 'div' }: Props) => {
  return (
    <Component
      className={css({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '[1px]',
        overflowX: 'hidden',
        overflowY: 'hidden',
        position: 'absolute',
        whiteSpace: '[nowrap]',
        width: '[1px]',
      })}
    >
      {children}
    </Component>
  );
};
